import React, { useState } from "react";
import { Form, Button } from "react-bootstrap";
import { setSuperAdminLoginDate, validateSuperAdmin } from "../../../helper";
import strings from "../../../constants/strings";

export default function AdminPanelLogin(props) {
  const [username, setUsername] = useState(null);
  const [password, setPassword] = useState(null);
  const { setLoggedIn } = props;
  return (
    <Form
      className="w-50 m-auto"
      style={{ paddingTop: "25vh" }}
      onSubmit={async (event) => {
        event.preventDefault();
        await validateSuperAdmin(username, password).then((result) => {
          if (result) {
            setSuperAdminLoginDate();
            setLoggedIn(true);
          } else {
            alert("Unauthorised");
          }
        });
      }}
    >
      <Form.Group className="h-100">
        <Form.Label className="landing-label">{strings.USERNAME}</Form.Label>
        <Form.Control
          className="landing-input"
          type="text"
          placeholder="Enter username"
          value={username || ""}
          onChange={(event) => setUsername(event.target.value)}
        />
      </Form.Group>
      <Form.Group className="h-100">
        <Form.Label className="landing-label">{strings.PASSWORD}</Form.Label>
        <Form.Control
          className="landing-input"
          type="password"
          placeholder="Enter password"
          value={password || ""}
          onChange={(event) => setPassword(event.target.value)}
        />
      </Form.Group>
      <div className="d-flex justify-content-center">
        <Button
          className="landing-button w-50"
          style={{ height: "3rem" }}
          type="submit"
        >
          {strings.LOGIN}
        </Button>
      </div>
    </Form>
  );
}
